import React from 'react';
import Header from "./Header/header";
import Banner from './Banner/banner';
import FloatingForm from "./FloatingForm/floatingForm";
import CoBrandingCustomerJourney from './CoBrandingCustomerJourney/cobranding.customer.journey.jsx';
import Notification from '../Notification/notification';
import { getCampaignDefaults } from "../../selectors";
import { marketCodeChanged } from "../../actions";
import { toggleNoInvitationDialog } from '../../actions/loanApplicationActions';
import { MarketCodes } from "../../marketCodes";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { LandingCodes } from "../../landingCodes";

export class CoBrandedLandingPage extends React.Component {

  componentDidMount() {
    this.props.marketCodeChanged(MarketCodes.DIRECT_MAILER, LandingCodes.AADVANTAGE);
  }

  render() {
    return (
      <article>
        <Header />
        <Banner campaignDefaults={this.props.campaignDefaults} />
        <FloatingForm toggleNoInvitationDialog={this.props.toggleNoInvitationDialog}/>
        <CoBrandingCustomerJourney />
        <Notification />
      </article>
    );
  }
}

CoBrandedLandingPage.propTypes = {
  marketCodeChanged: PropTypes.func.isRequired,
  campaignData: PropTypes.object
};

const mapStateToProps = (state) => ({
  campaignDefaults: getCampaignDefaults(state)
});

const mapDispatchToProps = { marketCodeChanged, toggleNoInvitationDialog };

export default connect(mapStateToProps, mapDispatchToProps)(CoBrandedLandingPage);
